export default {
  buttons: {
    save: 'Enregistrer',
    confirm: 'Confirmer',
    cancel: 'Annuler',
  },
  confirmation: {
    title: 'Voulez-vous vraiment synchroniser avec les services externes ?',
  },
};
